export class OldLabInfo {
  id?: string;
  labDate: string;
  noLabResult: boolean;
  isOrderPlaced: boolean;
  where: string;
  whenDate: string;
  notes: string;
  type: string;
  /** Resolved from clinical order attachment in API responses; sent on save to link the order. */
  documentId: string;
  encounterId: string;
  verifiedBy: string;
  verifiedAt: string;
  updatedBy?: string;
  updatedAt?: string;
  /** Linked PHI clinical order (procedure room panel labs). */
  clinicalOrderId?: string;
  /** Per-analyte result flags sent with save (not persisted on lab row). */
  analyteResultFlags?: Record<string, string>;
  labResults: {
    coumadin?: boolean;
    inr?: boolean;
    hemoglobin?: number | "";
    potassium?: number | "";
    creatinine?: number | "";
    calcium?: number | "";
    anGap?: number | "";
    bun?: number | "";
    carbonDioxide?: number | "";
    hgb?: number | "";
    hct?: number | "";
    sodium?: number | "";
    glucose?: number | "";
    chloride?: number | "";
    eGFR?: number | "";
    maxContrast?: number | "";
    pregnancyTest?: string;
    /** Prothrombin time — procedure room PT lab. */
    ptResult?: number | "";
    /** INR numeric result — procedure room INR lab. */
    inrResult?: number | "";
  };
  constructor(encounterId: string, labType: LabType) {
    this.encounterId = encounterId;
    this.type = labType;
    this.labResults = {};
  }
}

export enum LabType {
  FullMetabolic = "Full Metabolic",
  Chem8 = "Chem 8",
  PregnancyTest = "Pregnancy Test",
  EGFR = "eGFR",
  PT = "PT",
  INR = "INR",
  Ultrasound = "Ultrasound",
  ABI = "ABI",
}

/**
 * Lab types in the procedure room Orders accordion (stored in `labs` with shared `clinicalOrderId` FK).
 * Blood Glucose uses `glucose`; ACT uses `act` — same clinical-order lifecycle.
 */
export const PROCEDURE_ROOM_LAB_TYPES: readonly string[] = [
  LabType.FullMetabolic,
  LabType.Chem8,
  LabType.PregnancyTest,
  LabType.EGFR,
  LabType.PT,
  LabType.INR,
];
